import {
  LogOutIcon,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems
} from '@itsrever/design-system'
import { clsx } from 'clsx'
import { useAuth0 } from '@auth0/auth0-react'
import { usePostHog } from 'posthog-js/react'
import { useTranslation } from 'react-i18next'

export const UserSection = () => {
  const { t } = useTranslation()
  const posthog = usePostHog()
  const { logout, user } = useAuth0()

  const userName = user?.name?.match(/([^@]+)/) ?? ['']

  const handleLogout = () => {
    posthog.reset()
    logout({ logoutParams: { returnTo: window.location.origin } })
  }

  return (
    <Menu>
      <MenuButton
        className={clsx(
          'grid w-full grid-cols-[2rem_auto] content-start items-center gap-3 rounded-lg p-2',
          'hover:bg-[#2C3242]'
        )}
        styled={false}
      >
        <span
          className={clsx(
            'flex size-8 shrink-0 grow-0 items-center justify-center rounded-full uppercase',
            'bg-white/25 text-white'
          )}
        >
          {userName[0].charAt(0)}
        </span>
        <p className="truncate text-left text-sm text-[#CACFD8]">
          {userName[0]}
        </p>
      </MenuButton>

      <MenuItems
        anchor={{ to: 'top start', gap: '6px' }}
        className={clsx(
          'rounded-lg border border-solid border-[#353C4E] bg-[#1D222E]',
          'w-[var(--button-width)]'
        )}
        styled={false}
      >
        <MenuItem>
          <p
            className={clsx(
              'cursor-pointer rounded-md p-3 text-sm text-[#CACFD8]',
              'data-[focus]:bg-[#2C3242]/70',
              'flex items-center gap-2'
            )}
            onClick={handleLogout}
          >
            <LogOutIcon />
            {t('drawer_pages.log_out')}
          </p>
        </MenuItem>
      </MenuItems>
    </Menu>
  )
}

export default UserSection
